module.exports = __webpack_public_path__ + "static/img/smartstation11.a7ac4a41.png";